export default __webpack_public_path__ + "static/media/storeMarker.5dae5e59.png";